import React, { useRef, useState, useEffect } from 'react'
import { Accordion, AccordionTab } from "primereact/accordion";
import { Api } from '../../../services/api';
import { useFormik } from 'formik';
import { useNavigate } from "react-router-dom";
import { Button } from 'primereact/button';
import { EstimatorTemplate } from '../../../services/Template/estimator-template';
import { Toast } from 'primereact/toast';
import { useParams } from 'react-router-dom';
import { InputNumber } from 'primereact/inputnumber';
import './Estimating.css';
import { FaCopy } from 'react-icons/fa';
import { useScreenshot } from 'use-react-screenshot'
import html2canvas from 'html2canvas';

const ViewEstimating = ({ projectId, archiveId }) => {

    const ref = useRef(null)
    const ref2 = useRef(null)
    const navigate = useNavigate();
    var { editId } = useParams();
    const [financials, setFinancials] = useState([]);
    const [preConstructionShedule, setPreConstructionShedule] = useState([]);
    const [projectData, setProjectData] = useState([]);
    const [projectBudget, setProjectBudget] = useState([]);
    const [ActionItems, setActionItems] = useState([]);
    const [Title, setTitle] = useState([]);
    const [estimatorProjectName, setEstimatorProjectName] = useState('');

    // ----------------------------------------------------------------------------

    useEffect(() => {
        getTemplateDetails(projectId);

        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, []);

    const getTemplateDetails = (id) => {

        var url = Api.API_BASE_URL + 'all-template/get-archive-estimator/' + archiveId + '/' + projectId;


        fetch(url, {
            method: "GET",


        })
            .then((response) => response.json())
            .then((response) => {


                if (response.error == '') {
                    editId = response.Estimator;
                    formik.setFieldValue('EstimatorId', response.Estimator)
                    setEstimatorProjectName(response.EstimatorProjectName)
                    formik.setFieldValue(`section_2`, response.sec_2);
                    setFinancials(response.sec_2);
                    formik.setFieldValue(`section_4`, response.sec_7);
                    setPreConstructionShedule(response.sec_7);

                    formik.setFieldValue(`section_5`, response.sec_4);
                    setProjectBudget(response.sec_4);
                    formik.setFieldValue(`section_6`, response.sec_5);
                    setActionItems(response.sec_5);

                    formik.setFieldValue(`section_7`, response.sec_6);
                    setTitle(response.sec_6);

                    formik.setFieldValue(`ConceptualEstimate`, response.sec_1.ConceptualEstimate);
                    formik.setFieldValue(`FSA`, response.sec_1.FSA);
                    formik.setFieldValue(`FSA`, response.sec_1.FSA);
                    formik.setFieldValue(`HardBid`, response.sec_1.HardBid);
                    formik.setFieldValue(`ChangeOrders`, response.sec_1.ChangeOrders);
                    formik.setFieldValue(`Selections`, response.sec_1.Selections);
                    formik.setFieldValue(`Total`, response.sec_1.Total);
                    formik.setFieldValue(`ProjectManager`, response.sec_1.ProjectManager);
                    formik.setFieldValue(`InteriorDesigner`, response.sec_1.InteriorDesigner);
                    formik.setFieldValue(`VPComments`, response.sec_1.VPComments);


                    formik.setFieldValue(`projectId`, response.sec_3.projectId);
                    formik.setFieldValue(`dear`, response.sec_3.dear);
                    formik.setFieldValue(`vpConstructionCommentsForAll`, response.sec_3.vpConstructionCommentsForAll);
                    formik.setFieldValue(`dearVPCComments`, response.sec_3.dearVPCComments);
                    formik.setFieldValue(`hereIsYourWeeklySummaryFrom`, response.sec_3.hereIsYourWeeklySummaryFrom);
                    formik.setFieldValue(`hereIsYourWeeklySummaryTo`, response.sec_3.hereIsYourWeeklySummaryTo);
                    formik.setFieldValue(`hereIsYourWeeklySummaryVPCComments`, response.sec_3.hereIsYourWeeklySummaryVPCComments);
                    formik.setFieldValue(`projectSummary`, response.sec_3.projectSummary);
                    formik.setFieldValue(`projectSummaryVPCComments`, response.sec_3.projectSummaryVPCComments);
                    formik.setFieldValue(`scheduleConstructionStartDate`, response.sec_3.scheduleConstructionStartDate);
                    formik.setFieldValue(`scheduleProjectCompletion`, response.sec_3.scheduleProjectCompletion);
                    formik.setFieldValue(`scheduleVPCComments`, response.sec_3.scheduleVPCComments);

                } else {
                    formik.setFieldValue('EstimatorId', 0)
                    setEstimatorProjectName(response.EstimatorProjectName)
                }



            })
            .catch((error) => {

                console.error("Error:", error);
            });
    }

    //? --------------------------------------------------

    const headerStyle = {
        background: "#FEC025",
        border: "1px solid #E9ECEF",
        textAlign: "center",
        fontSize: "18px",
    };

    const cellStyle = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        // textAlign: 'center',
    };

    const cellStylee = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        textAlign: 'end',
    };

    const cellStyleW = {
        border: "1px solid #E9ECEF",
        borderLeft: "2px solid #E9ECEF",
        backgroundColor: 'white',
        paddingTop: '5px'

    };

    const borderStyle = {
        // border: "1px solid #E9ECEF",
        // borderLeft: "2px solid #E9ECEF",

    };

    const yesCellStyle = {
        ...cellStyle,
        // background: "#FEC025",
    };



    const dropdownCellStyle = {
        ...yesCellStyle,
        padding: "0",
    };

    //? --------------------------------------------------

    //! ----------------------------------------------------------

    const priceBodyTemplatee = (rowData) => {

        if (rowData === '' || rowData === null) {
            return '';
        }
        let numberValue = Number(rowData);
        // Ensure rowData is a number after the conversion and it's not NaN
        if (isNaN(numberValue)) {

            return '';
        }

        const isNegative = rowData < 0; // Check if the value is negative

        return <span style={{ color: isNegative ? "red" : "black" }}>
            {formatCurrency(rowData)}

        </span>
    };
    const formatCurrency = (value) => {
        console.log(value)

        return value.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
    //! ----------------------------------------------------------

    // ----------------------------------------------------------------------------
    const renderTextArea = (fieldName, placeholder, formData = '', rowCount = 2) => (
        <textarea
            placeholder={placeholder}
            name={fieldName}
            rows={rowCount}
            id={fieldName}
            value={formData !== '' ? formData : formik.values[fieldName]}
            disabled={true}
            onChange={(e) => {
                console.log(e.target.value)
                formik.setFieldValue(fieldName, e.target.value)
            }} onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '16px', color: '#495057', display: 'flex', alignItems: 'center', paddingTop: '8px' }}
        ></textarea>
    );

    const renderInputArea = (fieldName, placeholder = '', type = 'text', formData = '') => (

        <input
            type={type}
            placeholder={placeholder}
            name={fieldName}
            id={fieldName}
            value={formData !== '' ? formData : formik.values[fieldName]}
            step="any"
            disabled={true}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value)
                console.log(fieldName);
                if (fieldName === 'section_4.0.PlannedCompletionDate') {
                    console.log('Testing');
                    formik.setFieldValue('scheduleConstructionStartDate', e.target.value)

                }
                if (fieldName === 'section_4.12.CurrentForecastCompletionDate') {
                    formik.setFieldValue('scheduleProjectCompletion', e.target.value)
                }


            }}
            onKeyDown={(e) => {
                if (e.key === 'Enter') {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{ width: '100%', height: '40px', boxSizing: 'border-box', border: 'none', borderRadius: '0px', fontSize: '16px', textAlign: 'center', marginTop: '0px', }}

        />
    );

    const renderInputAreaForAmount = (fieldName, formData = '') => (
        <InputNumber

            inputId="currency-us"
            value={formData != '' ? formData : formik.values[fieldName]}
            className="text-center"
            inputClassName={formik.values[fieldName] < 0 ? "is-negative" : "is-positive"}
            placeholder="$0.00"
            disabled={true}
            onChange={(e) => formik.setFieldValue(fieldName, e.value)}
            mode="currency"
            currency="USD"
            locale="en-US"
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault(); // Prevent form submission on Enter key press
                }
            }}
            style={{
                width: "100%",
                height: "40px",
                boxSizing: "border-box",
                border: "none",
                fontSize: "16px",
                textAlign: "center !important",
                marginTop: "0px",
            }}
        />
    );


    const renderSelect = (fieldName, formdata = '') => {
        var val = (formdata != '') ? formdata : formik.values[fieldName];
        console.log('val' + val);
        console.log('formdata' + formdata);
        console.log('fieldName' + formik.values[fieldName]);
        if (val == undefined) {
            val = 'N'
        }

        return <select
            name={fieldName}
            id={fieldName}
            value={formdata !== '' ? formdata : formik.values[fieldName]}
            className={'select-text-color-' + val}
            onChange={(e) => {
                formik.setFieldValue(fieldName, e.target.value);
            }}
            style={{ width: '100%', textAlign: 'center', fontSize:'16px',color:'white', backgroundColor: '#ff0000', border: 'none' }}
        >
            <option value="N">No</option>
            <option value="Y">Yes</option>
            {/* <option value="NA">NA</option> */}
        </select>

    };
    // ----------------------------------------------------------------------------

    const toast = useRef(null);

    const formik = useFormik({
        initialValues: EstimatorTemplate.getFormName(),
        validate: (data) => {

        },

        onSubmit: (data) => {
            console.log("data");
            console.log(data);

            data.user_id = localStorage.getItem('user_id');
            data.role_id = localStorage.getItem('role_id');

            var url = Api.API_BASE_URL + 'estimator-template/update/' + data.EstimatorId;
            if (data.EstimatorId == 0) {

                url = Api.API_BASE_URL + 'estimator-template/create';
            }

            fetch(url, {
                method: "POST",
                headers: {

                },
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error != '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                        //navigate('/estimating-dashboard')
                        // 
                    }

                })
                .catch((error) => {
                    console.error("Error:", error);
                });


        }
    });
    // ----------------------------------------------------------------------------

    const BudgetRemaining = (index,) => {
        var value = formik.values.section_2[index].Budget - formik.values.section_2[index].AmountUsed;
        if (value == '' || value == null || value == undefined || value == 'NaN') {
            value = 0;
        }
        formik.values.section_2[index].BudgetRemaining = value;


        return (
            <span>{priceBodyTemplatee(formik.values.section_2[index].BudgetRemaining)}</span>
        )
    }

    const ProjectedBudgetToCompalte = (index,) => {
        var value = formik.values.section_2[index].EstimatedHoursToComplete * formik.values.section_2[index].ChargeOutRate;
        if (value == '' || value == null || value == undefined || value == 'NaN') {
            value = 0;
        }
        formik.values.section_2[index].ProjectedBudgetToComplete = value;


        return (
            <span>{priceBodyTemplatee(formik.values.section_2[index].ProjectedBudgetToComplete)}</span>
        )
    }

    const OverUnderBudget = (index,) => {
        var value = formik.values.section_2[index].BudgetRemaining - formik.values.section_2[index].ProjectedBudgetToComplete;
        if (value == '' || value == null || value == undefined || value == 'NaN') {
            value = 0;
        }
        formik.values.section_2[index].OverUnderBudget = value;

        return (
            <span>{priceBodyTemplatee(formik.values.section_2[index].OverUnderBudget)}</span>
        )

    }


    //* -------------------------
    const copyImageToClipboard = (blob) => {
        // Check if Clipboard API is available
        if (navigator.clipboard && navigator.clipboard.write) {
            navigator.clipboard.write([
                new ClipboardItem({
                    [blob.type]: blob
                })
            ]).then(() => {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Image copied to clipboard' });
                console.log('Image copied to clipboard');
            }).catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Error copying image to clipboard' });
                console.error('Error copying image to clipboard:', error);
            });
        } else {
            console.error('Clipboard API not available');
        }
    };
    const elementRefs = [
        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),

    ];

    const takeScreenshotAndCopy = async () => {
        console.log('Take screenshot and copy to clipboard');
        console.log('Take screenshot and copy to clipboard', ref.current);

        try {
            const canvasPromises = elementRefs.map(async (ref) => {
                if (ref.current) {
                    return await html2canvas(ref.current);
                }
                return null;
            });

            const canvases = await Promise.all(canvasPromises);

            // Calculate total height of combined screenshots
            const totalHeight = canvases.reduce((acc, canvas) => acc + canvas.height, 0);

            // Create a new canvas to combine screenshots
            const combinedCanvas = document.createElement('canvas');
            combinedCanvas.width = Math.max(...canvases.map(canvas => canvas.width));
            combinedCanvas.height = totalHeight;

            // Draw screenshots onto the combined canvas
            const context = combinedCanvas.getContext('2d');
            let offsetY = 0;
            canvases.forEach(canvas => {
                context.drawImage(canvas, 0, offsetY);
                offsetY += canvas.height;
            });

            // Convert the combined canvas to a data URL
            const imageDataURL = combinedCanvas.toBlob(blob => {
                if (blob) {
                    // Copy blob to clipboard
                    copyImageToClipboard(blob);
                } else {
                    console.error('Error creating blob');
                }
            }, 'image/png');
            // const imageDataURL = combinedCanvas.toDataURL();

            // Do something with the data URL (e.g., display it, save it, etc.)
            console.log('Combined screenshot data URL:', imageDataURL);
        } catch (error) {
            console.error('Error taking screenshots:', error);
        }



    };
    //* -------------------------
    // ----------------------------------------------------------------------------

    return (
        <>
            <Toast ref={toast} />
            <form onSubmit={formik.handleSubmit} className='pm-template-form' >
                {/* <div className='flex d-flex justify-content-end top-button'>
                    <Button className="m-2 mx-4 mt-2 px-3 " severity="Secondary" type="button" title="Copy Client Weekly Update" onClick={takeScreenshotAndCopy} >
                        <strong className="mr-2">Copy weekly update</strong>
                        <FaCopy />
                    </Button>

                    <Button className="m-2 mx-4 mt-2 px-4 d-flex align-items-center" severity="success" type="submit">
                        <strong className="mr-2">Save</strong>
                        <i className="pi pi-save"></i>
                    </Button>
                </div> */}
                
                <div className="cardd" style={{  border: 'none', }} >
                    <Accordion multiple activeIndex={[0, 1, 2, 3, 4, 5, 6]}>

                        <AccordionTab header="Financials" className='mt-2'>
                            <div className="table-container" style={{ overflowX: "auto" }}>

                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...headerStyle, width: "400px", }}>
                                                Conceptual Estimate
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                FSA
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Hard Bid
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Change Orders
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Selections
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Total
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Project Manager
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Interior Designer
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                VP CONSTRUCTION COMMENTS
                                            </th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        <tr>
                                            <th style={{ ...cellStyleW }}> {renderInputArea(`ConceptualEstimate`, '', 'text')}</th>
                                            <th style={{ ...cellStyleW }}> {renderInputArea(`FSA`, '', 'text')}</th>
                                            <th style={{ ...cellStyleW }}> {renderInputArea(`HardBid`, '', 'number')}</th>
                                            <th style={{ ...cellStyleW }}> {renderInputArea(`ChangeOrders`, '', 'number')}</th>
                                            <th style={{ ...cellStyleW }}> {renderInputArea(`Selections`, '', 'number')}</th>
                                            <th style={{ ...cellStyleW }}> {renderInputArea(`Total`, '', 'text')}</th>
                                            <th style={{ ...cellStyleW }}> {renderInputArea(`ProjectManager`, '', 'text')}</th>
                                            <th style={{ ...cellStyleW }}> {renderInputArea(`InteriorDesigner`, '', 'text')}</th>
                                            <th style={{ ...cellStyleW }}> {renderInputArea(`VPComments`, '', 'text')}</th>


                                        </tr>
                                    </tbody>
                                </table>

                                <table style={{ borderCollapse: "collapse", marginTop: '20px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...headerStyle, width: "400px", }}>
                                                FINANCIALS
                                            </th>
                                            <th style={{ ...headerStyle, width: "100px", }}>
                                                Budget
                                            </th>
                                            <th style={{ ...headerStyle, width: "100px", }}>
                                                Amount Used
                                            </th>
                                            <th style={{ ...headerStyle, width: "80px", }}>
                                                Budget Remaining
                                            </th>
                                            <th style={{ ...headerStyle, width: "100px", }}>
                                                Estimated Hours to Complete
                                            </th>
                                            <th style={{ ...headerStyle, width: "100px", }}>
                                                Charge out Rate
                                            </th>
                                            <th style={{ ...headerStyle, width: "80px", }}>
                                                Projected Budget to Complete
                                            </th>
                                            <th style={{ ...headerStyle, width: "80px", }}>
                                                Over/Under Budget
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Comments
                                            </th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        {financials.map((item, index) => (
                                            <tr>
                                                <td style={cellStyleW} >
                                                    {renderTextArea(`section_2.${index}.Financials`, '', formik.values.section_2[index].Financials)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputAreaForAmount(`section_2.${index}.Budget`, formik.values.section_2[index].Budget,)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputAreaForAmount(`section_2.${index}.AmountUsed`, formik.values.section_2[index].AmountUsed,)}
                                                </td>
                                                <td style={{ ...cellStyle, textAlign: 'center' }}>
                                                    {BudgetRemaining(index)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_2.${index}.EstimatedHoursToComplete`, formik.values.section_2[index].EstimatedHoursToComplete,)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputAreaForAmount(`section_2.${index}.ChargeOutRate`, formik.values.section_2[index].ChargeOutRate,)}
                                                </td>
                                                <td style={{ ...cellStyleW, textAlign: 'center' }}>
                                                    {ProjectedBudgetToCompalte(index)}
                                                </td>
                                                <td style={{ ...cellStyleW, textAlign: 'center' }}>
                                                    {OverUnderBudget(index)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderTextArea(`section_2.${index}.VPComments`, '', formik.values.section_2[index].VPComments,)}
                                                </td>


                                            </tr>
                                        ))}

                                    </tbody>
                                </table>

                            </div>
                        </AccordionTab>

                        <AccordionTab header="Action Steps" className='mt-2'>
                            <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[0]}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                ACTION STEPS:
                                            </th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td style={{ ...borderStyle, display: 'flex' }}>
                                                Dear:{renderTextArea('dear', "")}
                                            </td>
                                        </tr>



                                        <tr>
                                            <td style={borderStyle}>Here is your weekly summary from:

                                                <input
                                                    type="date"
                                                    name='hereIsYourWeeklySummaryFrom'
                                                    value={formik.values.hereIsYourWeeklySummaryFrom}
                                                    onChange={(e) => { formik.setFieldValue('hereIsYourWeeklySummaryFrom', e.target.value) }}

                                                    style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', fontSize: '16px', textAlign: 'center', }}
                                                />

                                                To :
                                                <input
                                                    type="date"
                                                    name='hereIsYourWeeklySummaryTo'
                                                    value={formik.values.hereIsYourWeeklySummaryTo}
                                                    onChange={(e) => { formik.setFieldValue('hereIsYourWeeklySummaryTo', e.target.value) }}

                                                    style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', fontSize: '16px', textAlign: 'center', }}
                                                />
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={{ ...borderStyle, display: 'flex' }}>
                                                <td style={{ width: '180px', }}>Project Summary:</td>
                                                {renderTextArea('projectSummary', "")}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td style={borderStyle}>Schedule:   Construction process Start Date
                                                <input
                                                    type="date"
                                                    name='scheduleConstructionStartDate'
                                                    value={formik.values.scheduleConstructionStartDate}
                                                    readOnly
                                                    onChange={(e) => { formik.setFieldValue('scheduleConstructionStartDate', e.target.value) }}

                                                    style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', fontSize: '16px', background: "#F8F9FA", textAlign: 'center', }}
                                                />
                                                Projected Permit date
                                                <input
                                                    type="date"
                                                    name='scheduleProjectCompletion'
                                                    value={formik.values.scheduleProjectCompletion}
                                                    onChange={(e) => { formik.setFieldValue('scheduleProjectCompletion', e.target.value) }}
                                                    readOnly
                                                    style={{ width: '200px', height: '40px', boxSizing: 'border-box', border: 'none', fontSize: '16px', background: "#F8F9FA", textAlign: 'center', }}
                                                />
                                                Notes:
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                        <AccordionTab header="Pre Construction Scheduled Miletsones" className='mt-2'>
                            <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[1]}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>

                                        <tr>
                                            <th style={{ ...headerStyle, width: "400px", }}>
                                                Pre Construction Scheduled Miletsones
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Planned Completion Date
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Forecasted Completion Date
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Actual Completion Date
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Description of Expected Pre Construciton timelines.  Subject to change
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Notes:  If applicable, explain why there was a change to the Pre Construction schedule
                                            </th>
                                        </tr>

                                    </thead>

                                    <tbody>
                                        {preConstructionShedule.map((item, index) => (
                                            <tr>
                                                <td style={cellStyleW} >
                                                    {
                                                        renderTextArea(`section_4.${index}.preConstructionShedule`, '', formik.values.section_4[index].preConstructionShedule)
                                                    }
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_4.${index}.PlannedCompletionDate`, '', 'date', formik.values.section_4[index].PlannedCompletionDate)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_4.${index}.CurrentForecastCompletionDate`, '', 'date', formik.values.section_4[index].CurrentForecastCompletionDate)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_4.${index}.ActualCompletionDate`, '', 'date', formik.values.section_4[index].ActualCompletionDate)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_4.${index}.Description`, '', 'text', formik.values.section_4[index].Description)}
                                                </td>

                                                <td style={cellStyleW}>
                                                    {renderTextArea(`section_2.${index}.Notes`, '', formik.values.section_4[index].Notes,)}
                                                </td>
                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                        <AccordionTab header="Project Budget" className='mt-2'>
                            <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[2]}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>
                                        <tr>
                                            <th style={{ ...headerStyle, width: "400px" }}>
                                                Project Budget
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                Amount
                                            </th >
                                            <th style={{ ...headerStyle, minWidth: "auto" }}>
                                                PRE CONSTRUCTION MANAGER COMMENTS
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {projectBudget.map((item, index) => (
                                            <tr>
                                                <td style={cellStyleW} >
                                                    {
                                                        renderTextArea(`section_5.${index}.ProjectBudget`, '', formik.values.section_5[index].ProjectBudget)
                                                    }
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputAreaForAmount(`section_5.${index}.Amount`, formik.values.section_5[index].Amount)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_5.${index}.PreConstManagerComments`, '', 'text', formik.values.section_5[index].PreConstManagerComments)}
                                                </td>
                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                        <AccordionTab header="Action Items" className='mt-2'>
                            <div className="table-container" style={{ overflowX: "auto" }} ref={elementRefs[3]}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>

                                        <tr>
                                            <th style={{ ...headerStyle, width: "auto" }}>
                                                Action Items
                                            </th>
                                        </tr>

                                    </thead>
                                    <tbody>

                                        {ActionItems.map((item, index) => (
                                            <tr>
                                                <td style={cellStyleW} >
                                                    {renderTextArea(`section_6.${index}.ActionItems`, '', formik.values.section_6[index].ActionItems)}
                                                </td>
                                            </tr>
                                        ))}


                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                        <AccordionTab header="Planned Baseline" className='mt-2'>
                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>

                                        <tr>
                                            <th style={{ ...headerStyle, width: "400px", }}>

                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Planned Baseline Completion Date
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Current Forecast Completion Date
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Actual Completion Date
                                            </th>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                Done:  Yes or No
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                PRE CONSTRUCTION MANAGER COMMENTS
                                            </th>

                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                VP CONSTRUCTION OPS COMMENTS
                                            </th>
                                        </tr>

                                    </thead>

                                    <tbody>


                                        {Title.map((item, index) => (
                                            <tr>
                                                <td style={cellStyleW} >
                                                    {renderTextArea(`section_7.${index}.Title`, '', formik.values.section_7[index].Title)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_7.${index}.PlannedCompletionDate`, '', 'date', formik.values.section_7[index].PlannedCompletionDate)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_7.${index}.CurrentForecastCompletionDate`, '', 'date', formik.values.section_7[index].CurrentForecastCompletionDate)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_7.${index}.ActualCompletionDate`, '', 'date', formik.values.section_7[index].ActualCompletionDate)}
                                                </td>
                                                <td style={{ ...dropdownCellStyle, minWidth: '100px', height: '32px', }}>
                                                    {renderSelect(`section_7.${index}.Done`, '', 'text')}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_7.${index}.PreConstManagerComments`, '', 'text', formik.values.section_7[index].PreConstManagerComments)}
                                                </td>
                                                <td style={cellStyleW}>
                                                    {renderInputArea(`section_7.${index}.VPComments`, '', 'text', formik.values.section_7[index].VPComments,)}
                                                </td>
                                            </tr>
                                        ))}




                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                        <AccordionTab header=" VP CONSTRUCTION OPS COMMENTS" className='mt-2'>
                            <div className="table-container" style={{ overflowX: "auto" }}>
                                <table style={{ borderCollapse: "collapse", }}>
                                    <thead>

                                        <tr>
                                            <th style={{ ...headerStyle, minWidth: "auto", }}>
                                                VP CONSTRUCTION OPS COMMENTS
                                            </th>

                                        </tr>

                                    </thead>

                                    <tbody>

                                        <tr>
                                            <td style={cellStyleW}>
                                                {renderTextArea(`vpConstructionCommentsForAll`, '', '', 6)}
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>
                        </AccordionTab>

                    </Accordion>
                </div>
            </form>
        </>
    )
}

export default ViewEstimating